export const SET_USER = "SET_USER";
export const SET_USER_ERROR = "SET_USER_ERROR";
export const SET_USER_LOGGED_IN = "SET_USER_LOGGED_IN";
export const GET_USER = "GET_USER";
export const LOG_OUT = "LOG_OUT";

export const SET_AUTHORS = "SET_AUTHORS";

export const LOADING_ON = "LOADING_ON";
export const LOADING_OFF = "LOADING_OFF";

export const GET_OPTIONS = "GET_OPTIONS";
export const SET_OPTIONS = "SET_OPTIONS";
export const RE_FETCH = "RE_FETCH";

export const GET_LANG = "GET_LANG";
export const GET_LANG_ERROR = "GET_LANG_ERROR";
export const SET_LANG = "SET_LANG";

export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const SET_STOCK = "SET_STOCK";

export const GET_ARTESIAN = "GET_ARTESIAN";
export const GET_ARTESIAN_ERROR = "GET_ARTESIAN_ERROR";

export const GET_STORAGE = "GET_STORAGE";
export const GET_STORAGE_ERROR = "GET_STORAGE_ERROR";
